import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {gql} from "@irati/utils/gql"

export const orderDocumentsQuery = gql`
  query OrderDocuments($order_id: ID!) {
    orderDocuments(order_id: $order_id) {
      documents {
        hire_agreement
        line_manager_approval
      }
    }
  }
`

export const getOrderDocumentsQueryKey = getQueryNames(orderDocumentsQuery)[0]
